// @flow
import React, { Component } from 'react';
import { loadScripts } from '../../../../utils/scripts';

type Props = {
    content: Object,
    options: {
        scripts: array,
    },
};

export default class Wowza extends Component<Props> {
    componentDidMount() {
        if (this.props.content.video_id === '') return;

        const customScripts = this.props.options && this.props.options.scripts;

        if (customScripts) loadScripts(customScripts);
        else {
            const script = document.createElement('script');
            script.src = `//player.cloud.wowza.com/hosted/${
                this.props.content.video_id
            }/wowza.js`;
            script.id = `player_embed`;
            if (document.body) {
                document.body.appendChild(script);
            }
        }
    }

    componentWillUnmount() {
        const script = document.getElementById(`player_embed`);
        if (script) {
            script.outerHTML = '';
        }
    }

    render() {
        return <div id="wowza_player" />;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Asset/ContentInjectors/Ovp/Wowza.js